import { CombinatieKortingRates } from './interface';

export const rates: CombinatieKortingRates = {
    senior: {
        2020: [
            { to: 5_073, base: 0 },
            { to: 30_234, percentage: 5.963, offset: -5_072 },
            { base: 1_502 },
        ],
        2021: [
            { to: 5_154, base: 0 },
            { to: 29_739, percentage: 5.926, offset: -5_153 },
            { base: 1_458 },
        ],
        2022: [
            { to: 5_220, base: 0 },
            { to: 27_350, percentage: 5.921, offset: -5_219 },
            { base: 1_311 },
        ],
        2023: [
            { to: 5_548, base: 0 },
            { to: 29_076, percentage: 5.9, offset: -5_547 },
            { base: 1_389 },
        ],
        2024: [
            { to: 6_074, base: 0 },
            { to: 31_838, percentage: 5.9, offset: -6_073 },
            { base: 1_522 },
        ]
    },
    nonSenior: {
        2020: [
            { to: 5_073, base: 0 },
            { to: 30_234, percentage: 11.450, offset: -5_072 },
            { base: 2_881 },
        ],
        2021: [
            { to: 5_154, base: 0 },
            { to: 29_739, percentage: 11.450, offset: -5_153 },
            { base: 2_815 },
        ],
        2022: [
            { to: 5_220, base: 0 },
            { to: 27_350, percentage: 11.450, offset: -5_219 },
            { base: 2_534 },
        ],
        2023: [
            { to: 5_548, base: 0 },
            { to: 29_075, percentage: 11.450, offset: -5_547 },
            { base: 2_694 },
        ],
        2024: [
            { to: 6_074, base: 0 },
            { to: 31_838, percentage: 11.450, offset: -6_073 },
            { base: 2_950 },
        ]
    },
};
